import { useMe } from './use-me'

export function useIsLensoraAdmin() {
  const { data } = useMe()
  return data?.user.isLensoraAdmin ?? false
}
